/**
 * The participles worth offering for a root.
 *
 * A participle is a *kṛdanta* — a root plus a kṛt affix — which then declines
 * like any other stem, in all three genders. So *gam* + Śatṛ gives the stem
 * *gacchat*, which declines *gacchan, gacchantau, gacchantaḥ*.
 *
 * Nothing here is special-cased. The affix is handed to the engine and the
 * derivation follows; a root that does not take a given affix simply yields
 * nothing, which is why *gam* has no ŚānaC (it is parasmaipada only).
 */

export type ParticipleEntry = {
    /** The kṛt affix, as the engine names it. */
    krt: string;
    /** Its traditional name. */
    name: string;
    /** What it means, in the terms a learner meets. */
    gloss: string;
};

export const PARTICIPLES: ParticipleEntry[] = [
    { krt: "Satf", name: "śatṛ", gloss: "present active — “going”" },
    { krt: "SAnac", name: "śānac", gloss: "present middle" },
    { krt: "kta", name: "kta", gloss: "past passive — “gone”" },
    { krt: "ktavatu", name: "ktavatu", gloss: "past active — “having gone”" },
    { krt: "kvasu", name: "kvasu", gloss: "perfect active" },
    { krt: "kAnac", name: "kānac", gloss: "perfect middle" },
    { krt: "tavya", name: "tavya", gloss: "gerundive — “to be gone to”" },
    { krt: "anIyar", name: "anīyar", gloss: "gerundive" },
    { krt: "yat", name: "yat", gloss: "gerundive" },
];
